module.exports = __webpack_public_path__ + "img/fullpage.443779df.jpg";